export const LANG = {
    OPEN_NUMBER: 'Open number',
    MARK_CELL: 'Mark cell',
    DIFFICULTY: 'Difficulty',
    BEGINNER: 'Beginner',
    INTERMEDIATE: 'Intermediate',
    EXPERT: 'Expert'
}